<template>
  <div class="between_item between_left">
    <card title="巡检路线">
      <div class="check_line_box box_style">
        <div class="check_line" v-for="(line, lineIndex) in checkLineList" :key="lineIndex">
          <div class="line_bg" :class="`style1`"></div>
          <div class="line_item_list fb">
            <div
              class="line_item style1"
              v-for="(item, index) in line"
              :key="index"
              :class="{ active: isSelected(index) }"
            >
              <div class="dot"><span class="dot_around"></span></div>
              <p class="name">{{ item.name }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="card_chart box_style">
        <p class="title">巡检问题统计</p>
        <div class="content fb">
          <div class="chart_box" id="chartBox"></div>
          <div class="line"></div>
          <div class="info">
            <p class="light">{{ checkTaskInfo.count }}</p>
            <p>累计巡检次数</p>
          </div>
        </div>
      </div>
    </card>
    <card title="巡检记录" styles="margin-top:24px">
      <div class="card_table" id="cardTable2">
        <dv-scroll-board ref="checkListTable" :config="tableConfig" @click="clickCheckReview" />
      </div>
    </card>
    <div class="side_content" v-if="checkOverVisible">
      <div class="side_item" @click="checkOver">结束回放</div>
    </div>
  </div>
</template>

<script>
import Card from '@/components/Card.vue';
import * as Api from '@/api';
let timer;
const checkMockData = [
  {
    checkPoint: '水轮发电机组', //巡检点名称
    checkState: '正常', //检查的状态
    checkInfo: [
      { code: '', name: '定子温度1', value: '29.1°C' }, //---1
      { code: '', name: '定子温度2', value: '29.2°C' },
    ],
  },
  {
    checkPoint: '水轮发电机组', //巡检点名称
    checkState: '正常', //检查的状态
    checkInfo: [
      { code: '', name: '定子温度1', value: '29.1°C' }, //---1
      { code: '', name: '定子温度2', value: '29.2°C' },
    ],
  },
  {
    checkPoint: '水轮发电机组', //巡检点名称
    checkState: '正常', //检查的状态
    checkInfo: [
      { code: '', name: '定子温度1', value: '29.1°C' }, //---1
      { code: '', name: '定子温度2', value: '29.2°C' },
    ],
  },
  {
    checkPoint: '水轮发电机组', //巡检点名称
    checkState: '正常', //检查的状态
    checkInfo: [
      { code: '', name: '定子温度1', value: '29.1°C' }, //---1
      { code: '', name: '定子温度2', value: '29.2°C' },
    ],
  },
  {
    checkPoint: '水轮发电机组', //巡检点名称
    checkState: '正常', //检查的状态
    checkInfo: [
      { code: '', name: '定子温度1', value: '29.1°C' }, //---1
      { code: '', name: '定子温度2', value: '29.2°C' },
    ],
  },
  {
    checkPoint: '水轮发电机组', //巡检点名称
    checkState: '正常', //检查的状态
    checkInfo: [
      { code: '', name: '定子温度1', value: '29.1°C' }, //---1
      { code: '', name: '定子温度2', value: '29.2°C' },
    ],
  },
  {
    checkPoint: '调速器', //巡检点名称
    checkState: '正常', //检查的状态
    checkInfo: [
      { code: '', name: '导叶开度', value: '41.3%' },
      { code: '', name: '调速器油压', value: '13.93MPa' },
      { code: '', name: '机组频率', value: '49.9Hz' },
    ],
  },
  {
    checkPoint: '调速器', //巡检点名称
    checkState: '正常', //检查的状态
    checkInfo: [
      { code: '', name: '导叶开度', value: '41.3%' },
      { code: '', name: '调速器油压', value: '13.93MPa' },
      { code: '', name: '机组频率', value: '49.9Hz' },
    ],
  },
  {
    checkPoint: '调速器', //巡检点名称
    checkState: '正常', //检查的状态
    checkInfo: [
      { code: '', name: '导叶开度', value: '41.3%' },
      { code: '', name: '调速器油压', value: '13.93MPa' },
      { code: '', name: '机组频率', value: '49.9Hz' },
    ],
  },
  {
    checkPoint: '调速器', //巡检点名称
    checkState: '正常', //检查的状态
    checkInfo: [
      { code: '', name: '导叶开度', value: '41.3%' },
      { code: '', name: '调速器油压', value: '13.93MPa' },
      { code: '', name: '机组频率', value: '49.9Hz' },
    ],
  },
  {
    checkPoint: '调速器', //巡检点名称
    checkState: '正常', //检查的状态
    checkInfo: [
      { code: '', name: '导叶开度', value: '41.3%' },
      { code: '', name: '调速器油压', value: '13.93MPa' },
      { code: '', name: '机组频率', value: '49.9Hz' },
    ],
  },
  {
    checkPoint: '低压机组控制屏', //巡检点名称
    checkState: '正常', //检查的状态
    checkInfo: [
      { code: '', name: '励磁电压', value: '24.6V' }, //---1
      { code: '', name: '励磁电流', value: '2.1A' },
      { code: '', name: '系统电压', value: '380.1V' },
      { code: '', name: '系统频率', value: '50.01Hz' },
    ],
  },
  {
    checkPoint: '低压机组控制屏', //巡检点名称
    checkState: '正常', //检查的状态
    checkInfo: [
      { code: '', name: '励磁电压', value: '24.6V' }, //---1
      { code: '', name: '励磁电流', value: '2.1A' },
      { code: '', name: '系统电压', value: '380.1V' },
      { code: '', name: '系统频率', value: '50.01Hz' },
    ],
  },
  {
    checkPoint: '低压机组控制屏', //巡检点名称
    checkState: '正常', //检查的状态
    checkInfo: [
      { code: '', name: '励磁电压', value: '24.6V' }, //---1
      { code: '', name: '励磁电流', value: '2.1A' },
      { code: '', name: '系统电压', value: '380.1V' },
      { code: '', name: '系统频率', value: '50.01Hz' },
    ],
  },
  {
    checkPoint: '低压机组控制屏', //巡检点名称
    checkState: '正常', //检查的状态
    checkInfo: [
      { code: '', name: '励磁电压', value: '24.6V' }, //---1
      { code: '', name: '励磁电流', value: '2.1A' },
      { code: '', name: '系统电压', value: '380.1V' },
      { code: '', name: '系统频率', value: '50.01Hz' },
    ],
  },
];
export default {
  components: {
    Card,
  },
  data() {
    return {
      checkLineList: [
        [
          // { name: '巡检起点', type: '' },
          { name: '综合设备屏', type: '' },
          { name: 'UPS柜', type: '' },
          { name: '机组控制屏', type: '' },
          { name: '厂用配电屏', type: '' },
          { name: '蜗壳压力表', type: '' },
          { name: '尾水压力表', type: '' },
          { name: '进水阀控制箱', type: '' },
          { name: '进水阀', type: '' },
          { name: '机组冷却水管', type: '' },
          { name: '调速器', type: '' },
          { name: '机组制动器', type: '' },
          // { name: '巡检终点', type: '' },
        ],
      ],
      echartsOpt: {
        tooltip: {
          trigger: 'item',
        },
        legend: {
          orient: 'horizontal',
          left: 'left',
          textStyle: {
            color: '#99BCD6',
          },
        },
        series: [
          {
            name: 'Access From',
            type: 'pie',
            radius: '50%',
            data: [
              { value: 1, name: '未处理', itemStyle: { color: '#4F87F6' } },
              { value: 5, name: '已处理', itemStyle: { color: '#54E3F7' } },
            ],
            label: {
              show: true,
              color: '#99BCD6',
              formatter(param) {
                // correct the percentage
                return param.name + ' (' + param.percent + '%)';
              },
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 1)',
              },
            },
          },
        ],
      },
      tableConfig: {
        header: ['任务名称', '任务类型', '时间', '操作'],
        rowNum: 5,
        // waitTime: 60000,
        data: [],
        headerBGC: 'rgba(3,74,144,0.3)',
        columnWidth: [180, 140, 150, 130],
        align: ['center', 'center', 'center', 'center'],
        oddRowBGC: 'rgba(14,36,60,0.4)',
        evenRowBGC: 'rgba(14,36,60,0.8)',
      },
      checkOverVisible: false,
      checkTaskInfo: {
        count: 0,
        finish: 0,
        unfinished: 0,
      },
      curCheckCount: null,
      curCheckInfo: null,
      curRobotTaskList: [], //实时机器人任务列表
      curCheckInfoDetail: [], //xiangqing
    };
  },
  mounted() {
    this.renderPage();
    this.renderChart();
  },
  methods: {
    renderPage() {
      this.getTaskCount();
      this.getTaskList();
    },
    renderChart() {
      let myChart = this.$echarts.init(document.getElementById('chartBox'));
      myChart.setOption(this.echartsOpt);
    },
    clickCheckReview(e) {
      this.checkOver(); //先停止
      const clickItem = this.curRobotTaskList[e.rowIndex];
      this.getTaskDetail(clickItem.id);

      this.$bus.$emit('isStartCheck', true);

      this.checkOverVisible = true;
      // 取消高亮巡检线路
      setTimeout(() => {
        this.$Model.i3dHighLight('07', 'T3', '0');
      }, 300);

      setTimeout(() => {
        this.$Model.i3dStartLineCheck();
      }, 800);
      this.actionInterval();
      const videoEl = document.querySelector('#xgFlvRobotView video');
      // videoEl.playbackRate = 8;
      setTimeout(() => {
        videoEl.playbackRate = 8;
      }, 1000);
      console.log('videoEl', videoEl);
    },
    checkOver() {
      this.$bus.$emit('isStartCheck', false);

      this.checkOverVisible = false;
      this.$Model.i3dInit();
      this.actionStop();
    },
    // 获取任务数据
    getTaskCount() {
      Api.getTaskCount().then((res) => {
        if (res.success) {
          const { data } = res;
          this.checkTaskInfo = { ...this.checkTaskInfo, ...data };
        }
      });
    },
    // 获取任务列表
    getTaskList() {
      Api.getCheckRobotList().then((res) => {
        if (res.success) {
          const { data } = res;
          this.curRobotTaskList = data;
          this.renderTable(data);
        }
      });
    },
    // 获取任务详情
    getTaskDetail(id) {
      Api.getCheckRobotById({ id }).then((res) => {
        if (res.success) {
          const { data } = res;
          this.curCheckInfoDetail = data;
          console.log('this.curCheckInfoDetail.length :>> ', this.curCheckInfoDetail.length);

          this.$bus.$emit('curCheckInfoList', data);
          this.$Storage.set('curCheckInfoList', data);
        }
      });
    },

    renderTable(data) {
      const tableData = [];
      const typeMap = { 0: '机器人巡检' };
      for (let i = 0; i < data.length; i++) {
        tableData.push([
          `${data[i].planName}`,
          `${typeMap[data[i].type] || '巡检'}`,
          `${data[i].updateTime.substring(5)}`,
          `<span class="type2">回放</span>`,
        ]);
      }
      console.log('tableData :>> ', tableData);
      this.tableConfig['data'] = tableData;

      this.$refs['checkListTable'].updateRows(this.tableConfig.data);
    },
    actionInterval() {
      console.log('开始巡检 :>> ');
      let count = 0;
      this.curCheckCount = count;

      timer = setInterval(() => {
        this.curCheckCount = count;
        this.curCheckInfo = this.curCheckInfoDetail[count];
        this.$bus.$emit('curCheckInfo', this.curCheckInfoDetail[count]);
        count++;
        if (count == this.curCheckInfoDetail.length) {
          this.checkOver();
          // this.actionStop(); //
        }
      }, 6000);
    },
    isSelected(index) {
      return index === this.curCheckCount;
    },
    // 渲染巡检数据
    renderCheckData() {},
    actionStop() {
      clearInterval(timer);
      this.curCheckCount = null;
      console.log('巡检终止 :>> ');
    },
  },
  beforeDestroy() {
    this.checkOver();
  },
};
</script>

<style lang="scss" scoped>
.card_chart {
  width: 480px;
  height: 196px;
  margin-top: 25px;
  padding: 10px 10px;
  .content {
    margin-top: 20px;
  }
  .line {
    width: 1px;
    height: 102px;
    opacity: 0.25;
    border: 1px solid;
    border-image: linear-gradient(
        180deg,
        rgba(13, 165, 251, 0.05),
        rgba(33, 61, 222, 0.5),
        rgba(140, 235, 255, 0.55),
        rgba(38, 68, 245, 0.46),
        rgba(13, 169, 254, 0.19)
      )
      1 1;
    margin: 0 3px;
  }
  .chart_box {
    width: 350px;
    height: 150px;
  }
  .info {
    width: 150px;
    height: 112px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-left: 38px;
    padding-bottom: 20px;

    .light {
      text-align: center;
      font-size: 28px;
    }
  }
}
.check_line_box {
  .check_line {
    position: relative;
    .line_bg {
      width: 442px;
      height: 4px;
      background: rgba(3, 74, 144, 0.3);
      box-shadow: inset 0px 0px 51px 0px rgba(16, 84, 144, 0.2);
      border-radius: 2px;
      position: absolute;
      left: 0;
      right: 0;
      margin: auto;
      top: 8px;
      &.style1 {
        background: rgba(3, 74, 144, 0.3);
        box-shadow: inset 0px 0px 51px 0px rgba(16, 84, 144, 0.2);
      }
      &.style2 {
        background: rgba(131, 98, 163, 0.2);
        box-shadow: inset 0px 0px 51px 0px rgba(120, 102, 155, 0.1);
      }
      &.style3 {
        background: rgba(71, 108, 233, 0.17);
        box-shadow: inset 0px 0px 51px 0px rgba(92, 109, 172, 0.1);
      }
      &.style4 {
        background: rgba(237, 142, 82, 0.17);
        box-shadow: inset 0px 0px 51px 0px rgba(181, 140, 97, 0.1);
      }
    }
    .line_item_list {
      width: 95%;
      height: 180px;
      margin: auto;
      align-items: center;
      .line_item {
        display: flex;
        align-items: center;
        flex-direction: column;
        &.active {
          .dot {
            animation: breathe 2s infinite;
            background: #a1e775 !important;
            .dot_around {
              background: #accdff;
              box-shadow: 0px 0px 5px 0px rgba(193, 221, 255, 0.95);
            }
          }
        }
        .dot {
          width: 14px;
          height: 14px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          .dot_around {
            display: block;
            width: 6px;
            height: 6px;
            border-radius: 50%;
          }
        }
        p.name {
          writing-mode: vertical-rl;
          text-orientation: upright;
          height: 155px;
          margin-top: 10px;
          font-size: 16px;
          font-weight: 600;
          letter-spacing: 3px;
        }
        &.style1 {
          .dot {
            background: rgba(189, 228, 255, 0.12);
            box-shadow: inset 0px 0px 3px 0px rgba(65, 217, 251, 0.91);
            border-image: linear-gradient(318deg, rgba(123, 179, 255, 1), rgba(73, 201, 255, 1)) 1 1;
            .dot_around {
              background: #accdff;
              box-shadow: 0px 0px 5px 0px rgba(193, 221, 255, 0.95);
            }
          }
        }
        &.style2 {
          .dot {
            background: rgba(189, 203, 255, 0.12);
            box-shadow: inset 0px 0px 3px 0px rgba(65, 108, 251, 0.91);
            border-image: linear-gradient(317deg, rgba(98, 95, 255, 1), rgba(168, 167, 255, 1)) 1 1;
            .dot_around {
              background: #ccd7ff;
              box-shadow: 0px 0px 5px 0px rgba(177, 188, 241, 0.95);
            }
          }
        }
        &.style3 {
          .dot {
            background: rgba(189, 228, 255, 0.12);
            box-shadow: inset 0px 0px 3px 0px rgba(65, 217, 251, 0.91);
            border-image: linear-gradient(318deg, rgba(123, 179, 255, 1), rgba(73, 201, 255, 1)) 1 1;
            .dot_around {
              background: #accdff;
              box-shadow: 0px 0px 5px 0px rgba(193, 221, 255, 0.95);
            }
          }
        }
        &.style4 {
          .dot {
            background: rgba(255, 219, 189, 0.12);
            box-shadow: inset 0px 0px 3px 0px rgba(255, 178, 136, 0.57);
            border-image: linear-gradient(313deg, rgba(251, 131, 77, 1), rgba(241, 210, 175, 1)) 1 1;
            .dot_around {
              background: #ffddce;
              box-shadow: 0px 0px 5px 0px rgba(255, 233, 221, 0.57);
            }
          }
        }
      }
    }
  }
}
.card_table {
  width: 480px;
  height: 220px;
  // margin-top: 12px;
}

.side_content {
  width: 112px;
  // height: 218px;
  background: rgb(10, 30, 56, 0.85);
  // background: url('../../assets/hs/bg_次级导航背景.png') no-repeat center;
  position: fixed;
  left: 540px;
  background-size: 100% 100%;
  top: 95px;
  z-index: 99;
  .side_item {
    width: 90px;
    height: 34px;
    line-height: 34px;
    color: #fff;
    font-size: 20px;
    font-weight: 600;
    text-align: center;
    text-shadow: 0 0 9px #158eff;
    margin: 15px auto;
    cursor: pointer;
    &.active {
      background: url('../../assets/hs/btn次级导航选中.png') no-repeat center;
      color: #fff;
    }
  }
}
@keyframes breathe {
  0% {
    transform: scale(0.8);
  }
  25% {
    transform: scale(1.1);
  }
  50% {
    transform: scale(1.3);
  }
  80% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(0.8);
  }
}
</style>
